import {useCallback} from 'react';

import {DEFAULT_LOCALE} from 'src/constants';
import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountLocale} from 'src/openapi/admin/apis/GetAccountLocaleApi';
import {updateAccountLocale} from 'src/openapi/admin/apis/UpdateAccountLocaleApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Locale} from 'src/openapi/admin/models/Locale';

type Props = {
    accountId: number,
};

export const useFormatSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountLocale({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((locale: Locale) => apiDispatch(
        updateAccountLocale({accountId, locale}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: DEFAULT_LOCALE,
    });
};
